import { ElementOf } from "@shared/common/types/typeHelpers";

export const MOVEMENT_ACTION_TYPES = ["Move", "Teleport"] as const;
export const SINGLE_TRACK_ACTION_TYPES = [
  "Enter",
  "Exit",
  "Wait",
  "Combine",
  "Split",
  "AtBegin",
  "AtEnd",
  "Decloak",
  "Cloak",
  "Filler",
  "WrapperCombine",
  "WrapperSplit",
  "Wrapper",
] as const;
export const ACTION_TYPES = [...MOVEMENT_ACTION_TYPES, ...SINGLE_TRACK_ACTION_TYPES] as const;

export type MovementActionType = ElementOf<typeof MOVEMENT_ACTION_TYPES>;
export type SingleTrackActionType = ElementOf<typeof SINGLE_TRACK_ACTION_TYPES>;
export type ActionType = ElementOf<typeof ACTION_TYPES>;

const ACTION_TYPE_TRANSLATIONS: { [K in ActionType]: string } = {
  Move: "Beweging",
  Teleport: "Teleporteren",
  Enter: "Binnenkomen",
  Exit: "Verlaten",
  Wait: "Wachten",
  Combine: "Combineren",
  Split: "Splitsen",
  AtBegin: "Aan begin",
  AtEnd: "Aan eind",
  Decloak: "Verschijnen",
  Cloak: "Verdwijnen",
  Filler: "Opvuller",
  WrapperCombine: "Wrapper combineren",
  WrapperSplit: "Wrapper splitsen",
  Wrapper: "Wrapper",
};

export const ActionType = {
  isMoveOrTeleport: (actionType: ActionType): actionType is MovementActionType =>
    (MOVEMENT_ACTION_TYPES as readonly string[]).includes(actionType),
  isMove: (actionType: ActionType) => actionType === "Move",
  isSplitOrCombine: (actionType: ActionType) =>
    actionType === "Split" ||
    actionType === "Combine" ||
    actionType === "WrapperSplit" ||
    actionType === "WrapperCombine",
  getDutchTranslation: (actionType: ActionType): string => ACTION_TYPE_TRANSLATIONS[actionType],
};
